import { useContext, useState, useCallback } from 'react';
import { useModal2FA } from '../../../../../../../../widgets/modal2FA/Modal2FA/Modal2FA';
import CartWindow from '../CartWindow/CartWindow';
import UserContext, { StoreContext, UserProfileContext } from '../../../../../../../../common/utils/getContext';
import { LangContext } from '../../../../../../../../common/decorators/Language';
import { useRouter } from 'next/router';
// import axios from 'axios';
// import { API_SERVER_URL } from '../../../../../../../../common/utils/utils';
import { makeOrderFunc, deleteProducts } from '../../utils';
import { navigateV2, replaceUrl } from '../../../../../../../../common/utils/router';
// import { getConvertedValue_ } from '../cells/PaymentGT/helpers';
// const Decimal = require('decimal.js');
import css from '../CartWindow/CartWindow.module.scss';
import { Portal } from '../../../../../../../../hybrid/wrappers';
import T, { t } from '../../../../../../../../common/components/T';
import FormComponent from '../../../../../../../../widgets/form/FormComponent/FormComponent';
import ContentAlert from '../../../../../../../../widgets/contentAlert/ContentAlert';
// import { zendoStorage } from '../../../../../../../../hybrid/wrappers';

const CartCalculate = ({
    setAnswerAfterCheckout,
    storeData,
    selectedPayment,
    // setResponseComisson,
    setFormDataError,
    newUser,
    cartForm,
    setPaymentFormData,
    responseComisson,
    myRef,
    isComboPayment,
    selectedPaymentSystems,
    // convertedData,
    container,
    delivery,
    setActiveStep,
    partner,
    isOfficeRegister,
    initValue,
    profileData
}) => {
    const { userToken, setAlertData, lang, localization } = useContext(UserContext);
    const { updateProfileData } = useContext(UserProfileContext) || {};
    const { cartData, setCartData } = useContext(StoreContext);
    const { translation } = useContext(LangContext);
    const router = useRouter();
    const [allow, setAllow] = useState(true);
    const [mbankInfo, setMbankInfo] = useState(false);
    const [mbankInfoNext, setMbankInfoNext] = useState(false);
    // useEffect(() => {
    //     const currentPaymentSys = selectedPaymentSystems.find((item) => item?.keyType === 'paymentSys');
    //     const amountInMainCurrency = convertedData.find((item) => item?.id === currentPaymentSys?.id);

    //     if (selectedPaymentSystems?.length && currentPaymentSys && amountInMainCurrency) {
    //         const comissionData = {
    //             payment_system_id: currentPaymentSys?.id || storeData?.payment_system_id,
    //             account_currency_id: cartData?.main_currency?.id || cartData?.main_currency?.id,
    //             // payment_system_currency_id:
    //             //     delivery?.user_price?.finance_currency?.id ||
    //             //     currentPaymentSys?.selectedCurrency?.id ||
    //             //     storeData?.payment_currency_id,
    //             amount: amountInMainCurrency?.amount || cartData?.total_main_price,
    //             operation_type: 'payment',
    //             warehouse_id: storeData?.warehouse_id?.id,
    //             payment_system_currency_id: currentPaymentSys?.selectedCurrency?.id
    //         };

    //         axios({
    //             method: 'POST',
    //             url: `${API_SERVER_URL}/api/v1/shop/carts/${cartData?.id}/calculate-amount`,
    //             headers: {
    //                 ...(userToken ? { Authorization: `Bearer ${userToken}` } : {}),
    //                 'X-Requested-With': 'XMLHttpRequest',
    //                 'Content-Type': 'application/json;charset=UTF-8',
    //                 ...(lang ? { 'Accept-Language': lang } : {})
    //             },
    //             data: JSON.stringify(comissionData)
    //         })
    //             .then(async (data) => {
    //                 const convertComission =
    //                     cartData?.currency?.code !== cartData?.main_currency?.code &&
    //                     Number(data?.data?.data?.account_commission) > 0
    //                         ? await getConvertedValue_(
    //                               cartData?.main_currency?.code,
    //                               cartData?.currency?.code,
    //                               data?.data?.data?.account_commission,
    //                               lang,
    //                               userToken
    //                           )
    //                         : null;

    //                 const comissionAmount = convertComission?.data?.amount || data?.data?.data?.account_commission;
    //                 setResponseComisson({
    //                     ...data?.data?.data,
    //                     convertedComission: comissionAmount,
    //                     convertedComissionFormatted: convertComission?.data?.amount_formatted,
    //                     fullTotal: comissionAmount
    //                         ? new Decimal(comissionAmount).plus(cartData?.total_price).toString()
    //                         : cartData?.total_price
    //                 });
    //             })
    //             .then(() => {
    //                 setFormDataError({});
    //             })
    //             .catch(({ response }) => {
    //                 if (response?.status === 422) {
    //                     if (response?.data?.errors) {
    //                         setFormDataError(response?.data?.errors);
    //                         setAlertData({
    //                             type: 'error',
    //                             cont: Object.values(response?.data?.errors)
    //                                 .map((err) => err.join(' '))
    //                                 .join(' ')
    //                         });
    //                     }
    //                 }
    //             });
    //     } else {
    //         setResponseComisson(null);
    //     }
    // }, [
    //     cartData?.main_currency,
    //     selectedPayment,
    //     setResponseComisson,
    //     selectedPaymentSystems,
    //     convertedData,
    //     cartData?.currency,
    //     userToken,
    //     lang,
    //     cartData?.total_price,
    //     storeData?.payment_system_id,
    //     storeData?.payment_currency_id,
    //     cartData?.total_main_price,
    //     setFormDataError,
    //     delivery
    // ]);

    // useEffect(() => {
    //     return () => {
    //         zendoStorage.remove('isOfficeRegister');
    //     };
    // }, []);

    const makeOrder = useCallback(
        (func2Fa, code = false) => {
            const getTypeAccOrPayment = (el) => (el?.keyType === 'internalAccount' ? 'account' : 'payment');
            let paymentType_ = 'combo';
            let redirect_url = '';
            if (!isComboPayment) {
                if (selectedPaymentSystems?.length) {
                    paymentType_ = getTypeAccOrPayment(selectedPaymentSystems[0]);
                }
            }

            let payment_currency_id = null;
            const payments = selectedPaymentSystems.map((item) => {
                const payment_type = getTypeAccOrPayment(item);
                if (payment_type === 'payment') {
                    payment_currency_id = item.selectedCurrency.id;
                    redirect_url = replaceUrl('/store/redirect');
                }
                const amount =
                    payment_type === 'account'
                        ? cartData?.account_total_price
                        : !isComboPayment
                        ? Number(cartData.total_price)
                        : Number(item?.sumValue);
                // доработка по мультинаціональним гаманцям
                const account_currency_data = {};
                if (payment_type === 'account') {
                    account_currency_data.payment_id = item?.account_id;
                    account_currency_data.currency_account_id = item?.currency_account_id;
                }
                return {
                    payment_id: item?.id,
                    payment_type,
                    amount: isNaN(amount) ? 0 : amount,
                    ...account_currency_data
                };
            });

            return new Promise((res, rej) =>
                makeOrderFunc(
                    cartData,
                    storeData,
                    userToken,
                    lang,
                    setFormDataError,
                    setAlertData,
                    cartForm,
                    myRef,
                    newUser,
                    setAnswerAfterCheckout,
                    func2Fa,
                    code,
                    translation,
                    setAllow,
                    localization,
                    setPaymentFormData,
                    selectedPayment,
                    responseComisson,
                    updateProfileData,
                    paymentType_,
                    payments,
                    payment_currency_id,
                    redirect_url,
                    setActiveStep,
                    partner,
                    isOfficeRegister,
                    setMbankInfo
                )
                    .then((r) => res(r))
                    .catch((e) => rej(e))
            );
        },
        [
            cartData,
            cartForm,
            lang,
            localization,
            myRef,
            newUser,
            responseComisson,
            selectedPayment,
            setAlertData,
            setAnswerAfterCheckout,
            setFormDataError,
            setPaymentFormData,
            updateProfileData,
            storeData,
            translation,
            userToken,
            isComboPayment,
            selectedPaymentSystems,
            setActiveStep,
            partner,
            isOfficeRegister
        ]
    );

    const senderFunc2FA = useCallback(
        (code) => {
            return new Promise((res, rej) =>
                makeOrder(() => {}, code)
                    .then((r) => res(r))
                    .catch((e) => rej(e))
            );
        },
        [makeOrder]
    );

    const { Modal2FA, func2Fa } = useModal2FA({ event: 'shop__order' }, senderFunc2FA);

    const makeOrderFirst = useCallback(() => {
        makeOrder(func2Fa, false);
    }, [func2Fa, makeOrder]);

    const deleledProduct = useCallback(async () => {
        await deleteProducts(
            setAlertData,
            cartData,
            setCartData,
            userToken,
            lang,
            setFormDataError,
            router,
            isOfficeRegister,
            initValue,
            profileData
        );
    }, [
        cartData,
        lang,
        isOfficeRegister,
        router,
        setAlertData,
        setCartData,
        setFormDataError,
        userToken,
        initValue,
        profileData
    ]);

    return (
        <div className={css.cartWidow}>
            {mbankInfo ? (
                <Portal>
                    <div className={css.modalBank}>
                        <p className={css.modalTitle}>
                            {!mbankInfoNext?.code ? (
                                <T textName='mbank-modal-title-v1' defaultStr='Введите номер телефона' page='/store' />
                            ) : (
                                <T
                                    textName='mbank-modal-title-v2'
                                    defaultStr='Для продолжения оплаты введите OTP'
                                    page='/store'
                                />
                            )}
                        </p>
                        {!mbankInfoNext?.code ? (
                            <>
                                <ContentAlert
                                    type='info'
                                    message={
                                        <T
                                            textName='mbank-modal-info_title-v1'
                                            defaultStr='Укажите номер телефона, который привязан к приложению Мбанк'
                                        />
                                    }
                                    compStyles={{
                                        wrapper: css.alertWrap
                                    }}
                                />
                                <FormComponent
                                    sendData={{
                                        url: mbankInfo?.urls?.initiate,
                                        method: 'POST',
                                        afterSenderSuccess: (data, _, setAllowedSend) => {
                                            setAlertData({
                                                type: 'success',
                                                cont: data?.data?.comment
                                            });
                                            setAllowedSend(true);
                                            setMbankInfoNext(data.data);
                                        }
                                    }}
                                    buttons={[
                                        {
                                            type: 'cancel',
                                            buttonText: <T textName='decline_order' defaultStr='Отменить' page='all' />,
                                            clickFunc: () => {
                                                setMbankInfo(false);
                                                navigateV2('/office');
                                            }
                                        },
                                        {
                                            type: 'ok',
                                            buttonText: <T textName='mbank-modal-btn' defaultStr='Продолжить' page='/store' />
                                        }
                                    ]}
                                    data={[
                                        {
                                            attribute: 'phone',
                                            default_value: null,
                                            disabled: false,
                                            group: 'info',
                                            subgroup: 'first',
                                            hint: null,
                                            options: [],
                                            placeholder: 'XXX-XX-XX',
                                            required: true,
                                            title: {
                                                body: t('store-mbank-phone', 'Номер телефона', '/store', translation)
                                            },
                                            value: mbankInfo?.phone,
                                            type: 'phone-widget'
                                        }
                                    ]}
                                    formStyles={{
                                        phone: {
                                            error: {
                                                wrapper: css.phoneErrorText
                                            }
                                        }
                                    }}
                                />
                            </>
                        ) : (
                            <>
                                <ContentAlert
                                    type='info'
                                    message={
                                        <T
                                            textName='mbank-modal-info_title-v2'
                                            defaultStr='Код подтверждения отправлен в приложение Mbank. Код действителен в течение 1 минуты'
                                        />
                                    }
                                    compStyles={{
                                        wrapper: css.alertWrap
                                    }}
                                />
                                <FormComponent
                                    sendData={{
                                        url: mbankInfoNext?.urls?.confirm,
                                        method: 'POST',
                                        afterSenderSuccess: (data) => {
                                            setAlertData({
                                                type: 'success',
                                                cont: data?.data?.comment
                                            });
                                            navigateV2(
                                                `/store/order?id=${mbankInfo?.number}${
                                                    router?.query?.o === '1' ? '&pageFrom=register' : ''
                                                }${!userToken ? '&is_guest=1' : ''}`
                                            );
                                        }
                                    }}
                                    buttons={[
                                        {
                                            type: 'cancel',
                                            buttonText: <T textName='decline_order' defaultStr='Отменить' page='all' />,
                                            clickFunc: () => {
                                                setMbankInfo(false);
                                                navigateV2('/office');
                                            }
                                        },
                                        {
                                            type: 'ok',
                                            buttonText: <T textName='mbank-modal-btn' defaultStr='Продолжить' page='/store' />
                                        }
                                    ]}
                                    data={[
                                        {
                                            attribute: 'otp',
                                            disabled: false,
                                            hint: null,
                                            required: true,
                                            maxLength: 4,
                                            title: {
                                                body: t('store-otp', 'Введите код подтверждения', '/store', translation)
                                            },
                                            type: 'input'
                                        }
                                    ]}
                                />
                            </>
                        )}
                    </div>
                </Portal>
            ) : null}

            <CartWindow
                isMainCurrency={cartData?.currency?.id === cartData?.main_currency?.id}
                mainCurrency={cartData?.main_currency}
                total={cartData.total_price_formatted}
                totalMain={cartData?.total_main_price_formatted}
                total_marketing={cartData.total_marketing_price_formatted}
                itemLength={cartData?.items?.length}
                makeOrder={makeOrderFirst}
                setAllow={setAllow}
                allow={allow}
                deleteProducts={deleledProduct}
                responseComisson={responseComisson}
                container={container}
                cartData={cartData}
                delivery={delivery}
                setActiveStep={setActiveStep}
            />

            {Modal2FA}
        </div>
    );
};
export default CartCalculate;
